document.addEventListener("DOMContentLoaded", function () {
  var timestamp = localStorage.getItem("timestamp");
  var currentTimestamp = new Date().getTime() / 1000; // Current time in seconds

  function showElementsForReturningVisitors() {
    document.querySelector("#returning_test-wrapper").style.display = "block";
    var style = document.createElement("style");
    style.innerHTML = `
      #returning_test-wrapper {
      display: block !important;
      }
        `;
    document.head.appendChild(style);
  }

  function hideElementsForFirstTimeVisitors() {
    document.querySelector("#returning_test-wrapper").style.display = "none";
    var style = document.createElement("style");
    style.innerHTML = `
      #returning_test-wrapper {
      display: none !important;
      }

        `;
    document.head.appendChild(style);
  }

  if (timestamp !== null) {
    var epochGap = 3600; // 1 hour gap
    var jsTimestamp = new Date(parseInt(timestamp)).getTime() / 1000;
    var timeDifference = currentTimestamp - jsTimestamp;

    if (timeDifference > epochGap) {
      console.log(
        "Returning visitor detected, visiting after the specified gap"
      );
      showElementsForReturningVisitors();
    } else {
      console.log("Visitor is returning but within the specified gap");
      // No changes for visitors returning within the gap
      hideElementsForFirstTimeVisitors();
    }
  } else {
    console.log("First-time visitor detected");
    hideElementsForFirstTimeVisitors();
    localStorage.setItem("timestamp", new Date().getTime());
  }
});
